import type * as React from "react";
import { cn } from "@/lib/utils";

const control =
  "h-8 w-full min-w-0 rounded-md border border-input bg-background px-3 text-sm text-foreground shadow-inset placeholder:text-muted-foreground focus:border-ring focus:shadow-[inset_0_0_0_1px_var(--color-ring)] focus:outline-none disabled:bg-muted disabled:text-muted-foreground aria-invalid:border-danger-emphasis aria-invalid:shadow-none";

/** `mono` for URLs, paths, hosts and tokens: 13px (Primer's code-block size) sits level with 14px sans text. */
function Input({ className, mono, ...props }: React.ComponentProps<"input"> & { mono?: boolean }) {
  return <input data-slot="input" className={cn(control, mono && "font-mono text-[13px]", className)} {...props} />;
}

export { Input };
